import { render } from "./RentAcar.vue?vue&type=template&id=588e0945"
import script from "./RentAcar.vue?vue&type=script&lang=js"
export * from "./RentAcar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__